<!--https://element.eleme.cn/#/zh-CN/component/menu-->
<template>
  <div class="sellerMenu">
    <el-menu class="menu" background-color="#fff" text-color="#333" active-text-color="#ff0023" :unique-opened="true" :collapse-transition="false">
      <template v-for="(menu, index) in menuList">
        <el-menu-item :index="`${index}`" :key="index" class="menu_item">
          <template slot="title">
            <a :href="`${menu.url}`" :target="menu.target">
              <i :class="`iconfont ${menu.icon}`"></i>
              <span>{{ menu.name }}</span>
            </a>
          </template>
        </el-menu-item>
      </template>
    </el-menu>
  </div>
</template>

<style lang="scss" scoped>
@import "./style.scss";
</style>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      menuList: [],
      buyerMenu: {},
    };
  },
  computed: mapState({
    userInfo: (state) => state.app.userInfo,
  }),
  mounted() {
    this.getBuyerMenu();
  },
  methods: {
    getBuyerMenu() {
      this.$store.dispatch("header/buyerMenu", {}).then((data) => {
        this.buyerMenu = data || {};
        this.menuList = [
          {
            icon: "",
            name: "我的订单",
            target: "_self",
            url: "/order/person/orderList.do",
          },
          {
            icon: "",
            name: "售后订单",
            target: "_self",
            url: "/v/aftersales/orderList",
          },
          {
            icon: "",
            name: "采购订货",
            target: "_blank",
            url: "/recommend/page.do",
          },
          {
            icon: "",
            name: "我的集采",
            target: "_self",
            url: "/groupPurchase/my/toMyNxinGroupPurchase.do",
          },
          {
            icon: "",
            name: "我的余额",
            target: "_blank",
            url: "/payment/margin/myMargin.do",
          },
          {
            icon: "",
            name: "支付账户",
            target: "_self",
            url: "/v/buyer/account",
          },
          {
            icon: "",
            name: "我的优惠券",
            target: "_self",
            url: "/cashCoupon/pc/toPage.do",
          },
          {
            icon: "",
            name: "我的收藏",
            target: "_self",
            url: "/member/favorite/listPage.do",
          },
          {
            icon: "",
            name: "账单",
            target: "_blank",
            url: "/bill/page.do",
          },
          {
            icon: "",
            name: "地址信息",
            target: "_self",
            url: "/v/buyer/receive",
          },
          {
            icon: "",
            name: "我的企业",
            target: "_self",
            url: "/member/company/listPage.do",
          },
          {
            icon: "",
            name: "企业信息",
            target: "_self",
            url: this.buyerMenu.businessCenter,
          },
          {
            icon: "",
            name: "个人中心",
            target: "_self",
            url: this.buyerMenu.memberInfoUrl,
          },
          {
            icon: "",
            name: "积分中心",
            target: "_self",
            url: "/v/buyer/integral",
          },
          {
            icon: "",
            name: "常用车辆",
            target: "_self",
            url: "/v/buyer/comCart",
          },
          {
            icon: "",
            name: "自提人信息",
            target: "_self",
            url: "/v/buyer/pickUp",
          },
        ];
        if (this.buyerMenu.isUserEnterprise === true) {
          this.menuList.splice(
            this.menuList.findIndex((item) => item.name === "我的集采"),
            1
          );
          this.menuList.splice(
            this.menuList.findIndex((item) => item.name === "个人中心"),
            1
          );
        } else {
          this.menuList.splice(
            this.menuList.findIndex((item) => item.name === "企业信息"),
            1
          );
          /*this.menuList.splice(
            this.menuList.findIndex((item) => item.name === "支付账户"),
            1
          );*/
        }
        if (this.buyerMenu.isShowCompany !== true) {
          this.menuList.splice(
            this.menuList.findIndex((item) => item.name === "我的企业"),
            1
          );
        }
      });
    },
  },
};
</script>
